import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import { Container } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CardComponent from '../../components/CardComponent';
import { charts } from '../../utils/constants';
import 'antd/dist/antd.css';

const useStyles = makeStyles({
  container: {
    padding: 20
  },
  body: {
    width: '70%',
    maxWidth: 650,
    height: '80vh',
    backgroundColor: 'white',
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 10,
    padding: 20
  },
  close: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    top: 20
  }
});

const ChartContainer = () => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleOnPressModalOpen = props => {
    setModalData(props);
    toggleModal();
  };

  return (
    <Container className={classes.container}>
      <h2>Examples of how to load a Chart:</h2>
      <CardComponent
        query={charts.total_inv_amt.query}
        type={charts.total_inv_amt.type}
        title={charts.total_inv_amt.title}
        info={charts.total_inv_amt.info}
        resourceId={charts.total_inv_amt.resourceId}
        description={charts.total_inv_amt.description}
      />
      <CardComponent
        query={charts.total_reached.query}
        type={charts.total_reached.type}
        title={charts.total_reached.title}
        info={charts.total_reached.info}
        resourceId={charts.total_reached.resourceId}
        description={charts.total_reached.description}
      />
      <CardComponent
        query={charts.total_si.query}
        type={charts.total_si.type}
        title={charts.total_si.title}
        info={charts.total_si.info}
        resourceId={charts.total_si.resourceId}
        description={charts.total_si.description}
      />
      <CardComponent
        query={charts.si_by_indicator.query}
        type={charts.si_by_indicator.type}
        title={charts.si_by_indicator.title}
        info={charts.si_by_indicator.info}
      />
      <CardComponent
        query={charts.sroi.query}
        type={charts.sroi.type}
        title={charts.sroi.title}
        info={charts.sroi.info}
        resourceId={charts.sroi.resourceId}
        description={charts.sroi.description}
        onPressModalOpen={handleOnPressModalOpen}
      />
      <CardComponent
        query={charts.leverage.query}
        type={charts.leverage.type}
        title={charts.leverage.title}
        info={charts.leverage.info}
        resourceId={charts.leverage.resourceId}
        description={charts.leverage.description}
        onPressModalOpen={handleOnPressModalOpen}
      />
      <CardComponent
        query={charts.data_quality.query}
        type={charts.data_quality.type}
        title={charts.data_quality.title}
        info={charts.data_quality.info}
        resourceId={charts.data_quality.resourceId}
        onPressModalOpen={handleOnPressModalOpen}
      />
      <CardComponent
        query={charts.compliance.query}
        type={charts.compliance.type}
        title={charts.compliance.title}
        info={charts.compliance.info}
        resourceId={charts.compliance.resourceId}
      />
      <CardComponent
        query={charts.feedback.query}
        type={charts.feedback.type}
        title={charts.feedback.title}
        info={charts.feedback.info}
        resourceId={charts.feedback.resourceId}
        description={charts.feedback.description}
      />
      <CardComponent
        query={charts.ratings.query}
        type={charts.ratings.type}
        title={charts.ratings.title}
        info={charts.ratings.info}
      />
      <Modal
        open={modalOpen}
        onClose={() => console.log('close')}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.body}>
          {modalData && <CardComponent {...modalData} />}
          <CancelIcon onClick={toggleModal} className={classes.close} />
        </div>
      </Modal>
    </Container>
  );
};

export default ChartContainer;
